import {
    request
} from "./request";

export function getCancerByGene(genename) {
    return request({
        url: '/ascancer/api/sv/findcancerbygene',
        params: {
            genename
        }
    })
}

export function getPubmedByGeneAndCancer(genename, cancername) {
    return request({
        url: '/ascancer/api/sv/findpubmedbygeneandcancer',
        params: {
            genename,
            cancername
        }
    })
}

export function getExonToProteinByTxID(txid) {
    return request({
        url: '/ascancer/api/exontoprotein',
        params: {
            txid
        }
    })
}

export function getDomainByTxID(txid) {
    return request({
        url: '/ascancer/api/domain',
        params: {
            txid
        }
    })
}

export function getSequenceByTxID(txid) {
    return request({
        url: '/ascancer/api/sequence',
        params: {
            txid
        }
    })
}

export function getBpsByRange(chr, strand, range) {
    return request({
        url: '/ascancer/api/bps',
        params: {
            chr,
            strand,
            range
        }
    })
}

export function getPancancerPSIByEventID(eventid) {
    return request({
        url: '/ascancer/api/pancancer/psi',
        params: {
            eventid
        }
    })
}

export function getPancancerExpByGene(genename) {
    return request({
        url: '/ascancer/api/pancancer/exp',
        params: {
            genename
        }
    })
}